import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from 'react-dom/client';
import { ChatOnlyProvider } from '@/app/context/useChatOnly';
import { MicPermissionProvider } from '@/app/context/useMicrophone';
import { ModalProvider } from '@/app/context/useModal';
import { ModeProvider } from '@/app/context/useMode';
import { getAppConfig } from '@/lib/env';
import Provider from '@/queryClient/QueryProvider';
import globalCss from '@/styles/globals.css';
import EmbedFixedAgentClient from './agent-client';
/**
 * Detects the origin and sandbox ID of the currently executing script.
 */
const getScriptContext = () => {
    if (typeof window === 'undefined')
        return { origin: '', sandboxId: '' };
    const currentScript = document.currentScript;
    // If we have currentScript, use it directly (best for non-module scripts)
    if (currentScript instanceof HTMLScriptElement) {
        return {
            origin: currentScript.src ? new URL(currentScript.src).origin : '',
            sandboxId: currentScript.dataset.lkSandboxId || '',
            element: currentScript,
        };
    }
    // Fallback: This is less reliable if multiple scripts exist
    const scripts = Array.from(document.scripts);
    const ourScript = scripts.find((s) => s.src && (s.src.includes('embed-popup.js') || s.getAttribute('data-lk-sandbox-id')));
    return {
        origin: (ourScript === null || ourScript === void 0 ? void 0 : ourScript.src) ? new URL(ourScript.src).origin : '',
        sandboxId: (ourScript === null || ourScript === void 0 ? void 0 : ourScript.getAttribute('data-lk-sandbox-id')) || '',
        element: ourScript,
    };
};
const scriptContext = getScriptContext();
const sourceOrigin = scriptContext.origin;
const sandboxIdAttribute = scriptContext.sandboxId;
if (sourceOrigin) {
    // 1. Initialize the internal service state (instance-safe)
    // 2. Set the global fallback (for compatibility with legacy hooks)
    window.__AGENT_BASE_PATH__ = sourceOrigin;
}
if (sandboxIdAttribute) {
    const wrapper = document.createElement('div');
    wrapper.setAttribute('id', 'lk-embed-wrapper');
    // Ensure the host wrapper doesn't clip the robot or cause positioning shifts
    Object.assign(wrapper.style, {
        position: 'static',
        width: '100%',
        height: '0',
    });
    document.body.appendChild(wrapper);
    const shadowRoot = wrapper.attachShadow({ mode: 'open' });
    const styleTag = document.createElement('style');
    styleTag.textContent = globalCss;
    shadowRoot.appendChild(styleTag);
    const reactRoot = document.createElement('div');
    shadowRoot.appendChild(reactRoot);
    const fetchOrigin = sourceOrigin || window.location.origin;
    getAppConfig(fetchOrigin, sandboxIdAttribute)
        .then((appConfig) => {
        const root = ReactDOM.createRoot(reactRoot);
        root.render(_jsx(ModeProvider, { children: _jsx(MicPermissionProvider, { children: _jsx(ChatOnlyProvider, { children: _jsx(ModalProvider, { children: _jsx(Provider, { children: _jsx(EmbedFixedAgentClient, { appConfig: appConfig, assetsBasePath: sourceOrigin }) }) }) }) }) }));
    })
        .catch((err) => {
        console.error('LiveKit popup embed error - Error loading app config:', err);
    });
}
else {
    console.error('LiveKit popup embed error - no data-lk-sandbox-id attribute found on script tag. This is required!');
}
